var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.location))]),(_vm.table && _vm.table.length === 0)?_c('div',[_c('p',[_vm._v("\n      No Data for selected period\n    ")])]):(_vm.isLoading === true)?_c('div',[_c('p',[_vm._v("\n      Loading...\n    ")])]):(_vm.store.data[_vm.location] && _vm.store.data[_vm.location].error === true)?_c('div',[_c('p',[_vm._v("\n      Server Error\n    ")])]):(!_vm.isLoading && _vm.table && _vm.table.length !== 0)?_c('div',[(!_vm.isPivotView)?_c('div',[_c('BasicTableComponent',{staticStyle:{"width":"400px"},attrs:{"list":_vm.table,"totals":_vm.store.totals(_vm.location),"tableClass":"table2excel","tableID":_vm.location,"formatters":{
          'date' : ['d', 'ddd MM/DD/YY'], 
          'approved_count' :  ['n', '0,0'],
          'refund_count' :  ['n', '0,0'],
          'count' :  ['n', '0,0'],
        },"hideColumns":['group'],"columnOrder":['date', 'device_number'],"titles":{
          'card_type_key' : 'Card<br>Type',
          'device_number' : 'Device<br>Number',
          'amount' : 'Total<br>Amount',
          'count' : 'Total<br>Count',
          'approved_amount' : 'Approved',
          'approved_count' : 'Approved<br>Count',
          'refund_amount' : 'Refund',
          'refund_count' : 'Refund<br>Count',
        }}})],1):_c('div',[_c('BasicTableComponent',{staticStyle:{"width":"400px"},attrs:{"list":_vm.store.pivotData(_vm.location),"totals":_vm.store.pivotTotals(_vm.location),"tableClass":"table2excel","tableID":_vm.location,"formatters":{
          'date' : ['d', 'ddd MM/DD/YY'], 
          'Interac_#' :  ['n', '0,0'],
          'VISA_#' :  ['n', '0,0'],
          'M/C_#' :  ['n', '0,0'],
          'Amex_#' :  ['n', '0,0'],
          'Discovery_#' :  ['n', '0,0'],
        },"titles":{
          'Interac_amount' : 'Interac', 
          'Interac_#' : 'Interac<br>Count', 
          'VISA_amount' : 'Visa', 
          'VISA_#' : 'Visa<br>Count', 
          'M/C_amount' : 'M/C', 
          'M/C_#' : 'M/C<br>Count', 
          'Amex_amount' : 'Amex', 
          'Amex_#' : 'Amex<br>Count', 
          'Discovery_amount' : 'Discovery', 
        }}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }